export class VennHealthUtils {
    static uniqueArray(array: any[]): any[] {
        const uniqueArray = array.filter((item, index) => {
            const stringifiedItem = JSON.stringify(item);
            return index === array.findIndex(obj => {
                return JSON.stringify(obj) === stringifiedItem;
            });
        });
        return uniqueArray;
    }

    static isNullOrEmptyString(s: string): boolean {
        return !s;
    }

    // Accepts the array and key
    static groupBy = (array, key) => {
      // Return the end result
      return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
      }, {}); // empty object is the initial value for result object
    };

    // formats the groupBy function above into a usable key/value pair array group to easily iterate through
    static formatGroupedByIntoKVPArray(sourceArray: any[], groupByKey: string): any[] {
      const grouped = VennHealthUtils.groupBy(sourceArray, groupByKey);
      const final = [];
      Object.keys(grouped).forEach((key) => {
        console.log(key);
        const kvp = {
          key: key,
          values: []
        };
        grouped[key].forEach((object) => {
          console.log(object);
          kvp.values.push(object);
        });
        final.push(kvp);
      });
      return final;
    }

    static isEqualsJson = (obj1,obj2) => {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
  
      //return true when the two json has same length and all the properties has same value key by key
      return keys1.length === keys2.length && Object.keys(obj1).every(key=>obj1[key]==obj2[key]); 
    }
}
